export default "__VITE_ASSET__CdfQ55$X__"